// extracted by mini-css-extract-plugin
var _1 = "EquityHistoryStyle-module__adjusted-paper___Hc2Zb";
var _2 = "EquityHistoryStyle-module__adjusted-paper___Hc2Zb";
export { _1 as "adjusted-paper", _2 as "adjustedPaper" }
